import { boot } from 'quasar/wrappers'
import { bootstrapInsider } from 'src/functions/insider'

// Empilha o user no InsiderQueue e injeta o ins.js (nessa ordem — ver
// bootstrapInsider). No-op fora do cliente academiacoral.
export default boot(({ store }) => {
	bootstrapInsider(store)
})
